/**
 * Store Front API Service
 * Handles all API calls for the store-front application via DTC-Services
 */

import type {
    AuthResponse,
    LoginResponse,
    PartnerLiveResponse,
    SDKSettings,
    UserDetailsFormData,
    ValidEmailResponse,
} from '../store/types';
import { clearSession, dtcApi, getSession, setSession } from './dtc-api';

// Re-export session utilities
export { clearSession, getSession, setSession };

/**
 * Store Front API endpoints via DTC-Services
 */
export const storefrontAPI = {
    async login(accessToken: string, pin: string): Promise<LoginResponse> {
        return dtcApi.login(accessToken, pin);
    },

    async authenticate(sessionId: string, sessionToken: string): Promise<AuthResponse> {
        return dtcApi.authenticate(sessionId, sessionToken);
    },

    async isPartnerLive(): Promise<PartnerLiveResponse> {
        return dtcApi.isPartnerLive();
    },

    async checkValidEmail(): Promise<ValidEmailResponse> {
        return dtcApi.checkValidEmail();
    },

    async updateEmail(email: string): Promise<{ error?: string }> {
        return dtcApi.updateEmail(email);
    },

    async updateUserDetails(formData: UserDetailsFormData): Promise<{ error?: string }> {
        return dtcApi.updateUserDetails(formData);
    },

    async getSDKSettings(): Promise<SDKSettings & { error?: string }> {
        return dtcApi.getSDKSettings();
    },

    async resetPin(accessToken: string): Promise<{ status?: string; error?: boolean; message?: string }> {
        return dtcApi.resetPin(accessToken);
    },

    logout(): void {
        dtcApi.logout();
    },
};

export default storefrontAPI;
